import { render, staticRenderFns } from "./GliEditorBtn.vue?vue&type=template&id=0f76a124"
import script from "./GliEditorBtn.vue?vue&type=script&lang=js"
export * from "./GliEditorBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports